// @flow

export const ACV_DOWN_SELL_WARNING_MESSAGE =
  'New ACV is lower than the previously committed ACV. Please validate custom discounts with DSM';

export const ARR_GROWTH_POLICY_WARNING_MESSAGE =
  'This Commit Estimate does not satisfy the >=20% Renewal/Expansion Growth Policy, and will need TVP approval if any new or increased discounts are applied';

export const IS_IMPORTED_BACKEND_NAME = 'is_imported';
export const IS_GD_IMPORTED_BACKEND_NAME = 'is_gd_imported';
// TODO: Remove this once the backend is updated after renewal automation is live.
export const IS_SYSTEM_GENERATED_BACKEND_NAME = 'is_system_generated';
export const IS_ADMIN_EDITED_BACKEND_NAME = 'is_admin_edited';

export const PREVIOUS_CONTRACT_DETAILS_ENUMS = {
  TCV: {
    DISPLAY_NAME: 'TCV',
    BACKEND_NAME: 'previous_tcv',
  },
  DEAL_DURATION: {
    DISPLAY_NAME: 'Deal Duration',
    BACKEND_NAME: 'previous_deal_duration',
  },
  START_DATE: {
    DISPLAY_NAME: 'Start Date',
    BACKEND_NAME: 'previous_start_date',
  },
  END_DATE: {
    DISPLAY_NAME: 'End Date',
    BACKEND_NAME: 'previous_end_date',
  },
  ACV: {
    DISPLAY_NAME: 'ACV',
    BACKEND_NAME: 'previous_acv', // previous_acv is being calculated from previous_tcv and previous_deal_duration as it is not coming directly in the BE response
  },
  ARR: {
    DISPLAY_NAME: 'ARR',
    BACKEND_NAME: 'previous_arr',
  },
  RATE_CARD: {
    DISPLAY_NAME: 'Rate Card',
    BACKEND_NAME: 'previous_rate_card',
  },
  SECTION_TITLE: "Customer's Previous Commit Contract Details",
  BE_FIELD_NAME: 'last_contract_details',
};
